package com.cs.ejobin.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.layout.ContentScale
import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.client.statement.bodyAsBytes

@Composable
fun RemoteImage(
    url: String?,
    modifier: Modifier = Modifier,
    contentScale: ContentScale = ContentScale.Crop
) {
    val cleanUrl = url?.trim().orEmpty()
    if (cleanUrl.isBlank()) return

    var bmp by remember(cleanUrl) { mutableStateOf<ImageBitmap?>(null) }
    var loading by remember(cleanUrl) { mutableStateOf(true) }
    var error by remember(cleanUrl) { mutableStateOf(false) }

    LaunchedEffect(cleanUrl) {
        loading = true
        error = false
        bmp = null

        try {
            val finalUrl = if (cleanUrl.contains("?")) "$cleanUrl&ts=${kotlin.random.Random.nextInt()}"
            else "$cleanUrl?ts=${kotlin.random.Random.nextInt()}"

            val bytes = httpClient.get(finalUrl).bodyAsBytes()
            bmp = decodeImage(bytes)
        } catch (_: Throwable) {
            error = true
        } finally {
            loading = false
        }
    }

    Box(modifier = modifier) {
        when {
            loading -> {
                Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                    CircularProgressIndicator()
                }
            }
            !error && bmp != null -> {
                Image(
                    bitmap = bmp!!,
                    contentDescription = null,
                    modifier = Modifier.fillMaxSize(),
                    contentScale = contentScale
                )
            }
            else -> { }
        }
    }
}

private val httpClient by lazy { HttpClient() }

expect fun decodeImage(bytes: ByteArray): ImageBitmap